import { getCampaignUrl } from '@browsing/campaign';

import { CategoryTabIds } from '@shared/constants';

export function buildCampaignUrl(campaignIdentifier: string, categoryTabId?: string) {
    const isCustomCategoryTabId =
        categoryTabId !== CategoryTabIds.NEW_DEALS_TODAY &&
        categoryTabId !== CategoryTabIds.LEAVING_SOON;
    const resolvedCategoryTabId = isCustomCategoryTabId ? categoryTabId : undefined;

    return getCampaignUrl(campaignIdentifier, {
        categoryTabId: resolvedCategoryTabId,
    });
}

/**
 * Builds a direct URL for a given campaign and a set of categories.
 * @param {string} campaignIdentifier
 * @param {string[]} categoryIds
 * @param {object} filter Filter query for colors and prices.
 * @param {string} key Secret campaign key.
 */
export function buildCategoryUrl(
    campaignIdentifier: string,
    categoryIds: Array<string | number>,
    filter: Record<string, string | number> = null,
    key: string | number = null,
) {
    if (key) {
        filter = { ...filter, key };
    }

    return getCampaignUrl(campaignIdentifier, { categoryTabId: categoryIds, query: filter });
}
